

// import React, { useState, useEffect } from 'react';
// import {
//   PieChart,
//   Pie,
//   Cell,
//   ResponsiveContainer,
//   Legend,
//   Tooltip,
//   AreaChart,
//   Area,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   LineChart,
//   Line,
// } from 'recharts';
// import html2pdf from 'html2pdf.js';
// import { motion, AnimatePresence } from 'framer-motion';
// import {
//   FaChartLine,
//   FaWallet,
//   FaMoneyBillWave,
//   FaFilePdf,
//   FaWhatsapp,
//   FaShieldAlt,
//   FaBullseye,
//   FaRocket,
//   FaCalendarAlt,
//   FaPercentage,
//   FaStepForward,
//   FaHandHoldingUsd,
//   FaUserClock,
//   FaRupeeSign,
//   FaChartPie,
//   FaDownload,
//   FaShare,
//   FaCheckCircle,
//   FaArrowRight,
//   FaInfoCircle,
// } from 'react-icons/fa';

// import CalculatorForm from './CalculatorForm';

// const ComboCalculator = () => {
//   // Basic Details
//   const [clientName, setClientName] = useState('');
//   const [currentAge, setCurrentAge] = useState(30);
  
//   // SIP Phase Details
//   const [sipTenure, setSipTenure] = useState(20);
//   const [monthlySIP, setMonthlySIP] = useState(10000);
//   const [yearlyStepUp, setYearlyStepUp] = useState(10000);
//   const [expectedReturnSIP, setExpectedReturnSIP] = useState(12);
  
//   // Withdrawal Phase Details
//   const [immediateWithdrawal, setImmediateWithdrawal] = useState(true);
//   const [monthlyWithdrawal, setMonthlyWithdrawal] = useState(20000);
//   const [increaseWithdrawal, setIncreaseWithdrawal] = useState(true);
//   const [expectedReturnWithdrawal, setExpectedReturnWithdrawal] = useState(8);
//   const [withdrawalPeriod, setWithdrawalPeriod] = useState(30);
  
//   const [result, setResult] = useState(null);
//   const [chartData, setChartData] = useState([]);
//   const [withdrawalChartData, setWithdrawalChartData] = useState([]);
//   const [showForm, setShowForm] = useState(false);
//   const [activeTab, setActiveTab] = useState('investment');

//   const COLORS = ['#2e56b8', '#69bf74', '#ff9800', '#f44336', '#9c27b0'];

//   const formatCurrency = (amount) => {
//     return `₹${Number(amount || 0).toLocaleString('en-IN', {
//       maximumFractionDigits: 0,
//     })}`;
//   };

//   const formatLargeNumber = (amount) => {
//     if (amount >= 10000000) {
//       return `₹${(amount / 10000000).toFixed(2)} Cr`;
//     }
//     if (amount >= 100000) {
//       return `₹${(amount / 100000).toFixed(2)} L`;
//     }
//     return formatCurrency(amount);
//   };

//   const calculate = () => {
//     // SIP Phase Calculations
//     const monthlyRateSIP = expectedReturnSIP / 12 / 100;
//     const totalMonths = sipTenure * 12;
    
//     let sipFV = 0;
//     let sipContributions = [];
//     let yearlyData = [];
//     let currentSIP = monthlySIP;
    
//     for (let month = 1; month <= totalMonths; month++) {
//       sipFV = (sipFV + currentSIP) * (1 + monthlyRateSIP);
      
//       // Apply step-up at the beginning of each year
//       if (month % 12 === 0 && month < totalMonths) {
//         currentSIP += yearlyStepUp;
//       }
      
//       if (month % 12 === 0) {
//         const year = month / 12;
//         yearlyData.push({
//           year,
//           sipValue: sipFV,
//           invested: (() => {
//             let total = 0;
//             let sip = monthlySIP;
//             for (let y = 1; y <= year; y++) {
//               total += sip * 12;
//               if (y < year) sip += yearlyStepUp;
//             }
//             return total;
//           })(),
//         });
//       }
//     }
    
//     const totalInvestedSIP = (() => {
//       let total = 0;
//       let sip = monthlySIP;
//       for (let i = 0; i < sipTenure; i++) {
//         total += sip * 12;
//         sip += yearlyStepUp;
//       }
//       return total;
//     })();
    
//     const totalReturnsSIP = sipFV - totalInvestedSIP;
    
//     // Withdrawal Phase Calculations
//     let withdrawalBalance = sipFV;
//     const monthlyRateWithdrawal = expectedReturnWithdrawal / 12 / 100;
//     let currentWithdrawal = monthlyWithdrawal;
//     let totalWithdrawn = 0;
//     let withdrawalYears = 0;
//     let withdrawalData = [];
//     let monthsWithdrawn = 0;
    
//     if (immediateWithdrawal) {
//       while (withdrawalBalance > 0 && withdrawalYears < withdrawalPeriod) {
//         let yearWithdrawal = 0;
//         let yearlyWithdrawn = 0;
        
//         for (let month = 1; month <= 12; month++) {
//           if (withdrawalBalance <= 0) break;
          
//           withdrawalBalance = withdrawalBalance * (1 + monthlyRateWithdrawal) - currentWithdrawal;
//           totalWithdrawn += currentWithdrawal;
//           yearlyWithdrawn += currentWithdrawal;
//           monthsWithdrawn++;
          
//           if (withdrawalBalance <= 0) break;
//         }
        
//         withdrawalYears++;
//         withdrawalData.push({
//           year: withdrawalYears,
//           balance: Math.max(0, withdrawalBalance),
//           withdrawn: yearlyWithdrawn,
//           cumulativeWithdrawn: totalWithdrawn,
//         });
        
//         if (increaseWithdrawal && withdrawalBalance > 0) {
//           currentWithdrawal = currentWithdrawal * 1.03; // 3% annual increase
//         }
        
//         if (withdrawalBalance <= 0) break;
//       }
//     }
    
//     const withdrawalStartAge = currentAge + sipTenure;
//     const withdrawalEndAge = withdrawalStartAge + withdrawalYears;
    
//     setResult({
//       sipFV,
//       totalInvestedSIP,
//       totalReturnsSIP,
//       wealthMultiplier: sipFV / totalInvestedSIP,
//       withdrawalBalance: Math.max(0, withdrawalBalance),
//       totalWithdrawn,
//       withdrawalYears,
//       withdrawalStartAge,
//       withdrawalEndAge,
//       finalCorpus: Math.max(0, withdrawalBalance),
//       monthlyWithdrawalEnd: currentWithdrawal,
//     });
    
//     setChartData(yearlyData);
//     setWithdrawalChartData(withdrawalData);
//   };

//   useEffect(() => {
//     calculate();
//   }, [sipTenure, monthlySIP, yearlyStepUp, expectedReturnSIP, 
//       immediateWithdrawal, monthlyWithdrawal, increaseWithdrawal, 
//       expectedReturnWithdrawal, withdrawalPeriod]);

//   const handleFormSubmit = (userData) => {
//     const element = document.getElementById('advanced-result-content');
    
//     html2pdf()
//       .set({
//         margin: 0.5,
//         filename: `SIP_Plan_${userData.name || clientName || 'Report'}.pdf`,
//         image: { type: 'jpeg', quality: 1 },
//         html2canvas: { scale: 2 },
//         jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
//       })
//       .from(element)
//       .save();
    
//     setShowForm(false);
    
//     const whatsappMessage = `🏦 *Advanced SIP Investment Report*

// 👤 Client: ${userData.name || clientName || 'Investor'}

// 📊 *Investment Phase*
// 💰 Monthly SIP: ${formatCurrency(monthlySIP)}
// 📈 Yearly Step-Up: ${formatCurrency(yearlyStepUp)}
// ⏱️ SIP Tenure: ${sipTenure} Years
// 📊 Expected Return: ${expectedReturnSIP}%

// 💎 *Results*
// ✅ Total Invested: ${formatCurrency(result?.totalInvestedSIP)}
// 🚀 Final Corpus: ${formatCurrency(result?.sipFV)}
// 📈 Wealth Generated: ${formatCurrency(result?.totalReturnsSIP)}
// ⚡ Wealth Multiplier: ${result?.wealthMultiplier?.toFixed(2)}x

// ${immediateWithdrawal ? `
// 🔄 *Withdrawal Phase*
// 💸 Monthly Withdrawal: ${formatCurrency(monthlyWithdrawal)}
// 📈 Withdrawal Return: ${expectedReturnWithdrawal}%
// 📅 Withdrawal Duration: ${result?.withdrawalYears} Years
// 💰 Total Withdrawn: ${formatCurrency(result?.totalWithdrawn)}
// 🏦 Remaining Corpus: ${formatCurrency(result?.finalCorpus)}
// ` : ''}

// ---
// *Wisdom Consultancy*
// 📞 9726344477
// 📧 wisdom2secure@gmail.com`;

//     window.open(`https://wa.me/${userData.phone}?text=${encodeURIComponent(whatsappMessage)}`, '_blank');
//   };

//   const SummaryCard = ({ title, value, subtext, icon: Icon, color, gradient }) => (
//     <motion.div
//       whileHover={{ y: -5 }}
//       className={`bg-gradient-to-br ${gradient || 'from-white to-white'} rounded-2xl p-5 shadow-lg border border-gray-100`}
//     >
//       <div className="flex items-center justify-between mb-3">
//         <div className={`w-12 h-12 rounded-xl bg-${color}-100 flex items-center justify-center text-${color}-500`}>
//           <Icon className="text-2xl" />
//         </div>
//         <div className={`text-xs font-semibold px-3 py-1 rounded-full bg-${color}-50 text-${color}-600`}>
//           {title}
//         </div>
//       </div>
//       <h3 className="text-2xl font-bold text-gray-800">{value}</h3>
//       <p className="text-sm text-gray-500 mt-1">{subtext}</p>
//     </motion.div>
//   );

//   return (
//     <motion.div
//       initial={{ opacity: 0, y: 20 }}
//       animate={{ opacity: 1, y: 0 }}
//       className="bg-white rounded-[32px] shadow-2xl border border-gray-100 p-6 md:p-8"
//     >
//       {/* Header */}
//       <div className="mb-8">
//         <div className="inline-flex items-center gap-3 bg-gradient-to-r from-blue-50 to-indigo-50 px-5 py-3 rounded-full mb-5">
//           <div className="w-11 h-11 rounded-full bg-gradient-to-r from-[#2e56b8] to-[#4d7dff] flex items-center justify-center text-white">
//             <FaChartLine />
//           </div>
//           <span className="font-semibold text-gray-700">Advanced SIP + SWP Planning</span>
//         </div>
        
//         <h3 className="text-3xl font-bold text-gray-800 mb-3">
//           Smart Investment & Withdrawal Planner
//         </h3>
        
//         <p className="text-gray-500 leading-relaxed">
//           Plan your wealth creation with SIP, step-up investments, and systematic withdrawal strategy
//         </p>
//       </div>

//       {/* Main Grid */}
//       <div className="grid lg:grid-cols-2 gap-8">
//         {/* Input Section */}
//         <div className="space-y-6">
//           {/* Client Details */}
//           <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl p-5">
//             <h4 className="font-bold text-gray-700 mb-4 flex items-center gap-2">
//               <FaUserClock /> Client Details
//             </h4>
//             <div className="grid grid-cols-2 gap-4">
//               <div>
//                 <label className="block text-sm font-medium text-gray-600 mb-1">Client Name</label>
//                 <input
//                   type="text"
//                   value={clientName}
//                   onChange={(e) => setClientName(e.target.value)}
//                   placeholder="Enter name"
//                   className="w-full border border-gray-200 rounded-xl px-4 py-2 outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600 mb-1">Current Age (Years)</label>
//                 <input
//                   type="number"
//                   value={currentAge}
//                   onChange={(e) => setCurrentAge(Number(e.target.value))}
//                   className="w-full border border-gray-200 rounded-xl px-4 py-2 outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Investment Phase */}
//           <div className="bg-white border border-gray-100 rounded-2xl p-5 shadow-sm">
//             <h4 className="font-bold text-gray-700 mb-4 flex items-center gap-2">
//               <FaRupeeSign className="text-green-500" /> Investment Phase (SIP)
//             </h4>
            
//             <div className="space-y-4">
//               <div>
//                 <label className="block text-sm font-medium text-gray-600 mb-1">SIP Tenure (Years)</label>
//                 <input
//                   type="range"
//                   min="1"
//                   max="50"
//                   value={sipTenure}
//                   onChange={(e) => setSipTenure(Number(e.target.value))}
//                   className="w-full accent-blue-500"
//                 />
//                 <div className="text-center font-bold text-blue-600 mt-1">{sipTenure} Years</div>
//               </div>
              
//               <div>
//                 <label className="block text-sm font-medium text-gray-600 mb-1">Monthly SIP Amount (₹)</label>
//                 <input
//                   type="number"
//                   value={monthlySIP}
//                   onChange={(e) => setMonthlySIP(Number(e.target.value))}
//                   className="w-full border border-gray-200 rounded-xl px-4 py-2 outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
              
//               <div>
//                 <label className="block text-sm font-medium text-gray-600 mb-1">Yearly Step-Up SIP Amount (₹)</label>
//                 <input
//                   type="number"
//                   value={yearlyStepUp}
//                   onChange={(e) => setYearlyStepUp(Number(e.target.value))}
//                   className="w-full border border-gray-200 rounded-xl px-4 py-2 outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
              
//               <div>
//                 <label className="block text-sm font-medium text-gray-600 mb-1">Expected Return from SIP (% CAGR)</label>
//                 <input
//                   type="range"
//                   min="4"
//                   max="20"
//                   step="0.5"
//                   value={expectedReturnSIP}
//                   onChange={(e) => setExpectedReturnSIP(Number(e.target.value))}
//                   className="w-full accent-green-500"
//                 />
//                 <div className="text-center font-bold text-green-600 mt-1">{expectedReturnSIP}%</div>
//               </div>
//             </div>
//           </div>

//           {/* Withdrawal Phase */}
//           <div className="bg-white border border-gray-100 rounded-2xl p-5 shadow-sm">
//             <h4 className="font-bold text-gray-700 mb-4 flex items-center gap-2">
//               <FaHandHoldingUsd className="text-orange-500" /> Withdrawal Phase (SWP)
//             </h4>
            
//             <div className="space-y-4">
//               <div className="flex items-center justify-between">
//                 <label className="text-sm font-medium text-gray-600">Immediate Withdrawal after SIP Tenure</label>
//                 <button
//                   onClick={() => setImmediateWithdrawal(!immediateWithdrawal)}
//                   className={`px-4 py-2 rounded-xl font-semibold transition-all ${immediateWithdrawal ? 'bg-green-500 text-white' : 'bg-gray-200 text-gray-600'}`}
//                 >
//                   {immediateWithdrawal ? 'Yes' : 'No'}
//                 </button>
//               </div>
              
//               {immediateWithdrawal && (
//                 <>
//                   <div>
//                     <label className="block text-sm font-medium text-gray-600 mb-1">Monthly Withdrawal Amount (₹)</label>
//                     <input
//                       type="number"
//                       value={monthlyWithdrawal}
//                       onChange={(e) => setMonthlyWithdrawal(Number(e.target.value))}
//                       className="w-full border border-gray-200 rounded-xl px-4 py-2 outline-none focus:ring-2 focus:ring-blue-500"
//                     />
//                   </div>
                  
//                   <div className="flex items-center justify-between">
//                     <label className="text-sm font-medium text-gray-600">Increase Withdrawal Amount every Year</label>
//                     <button
//                       onClick={() => setIncreaseWithdrawal(!increaseWithdrawal)}
//                       className={`px-4 py-2 rounded-xl font-semibold transition-all ${increaseWithdrawal ? 'bg-green-500 text-white' : 'bg-gray-200 text-gray-600'}`}
//                     >
//                       {increaseWithdrawal ? 'Yes' : 'No'}
//                     </button>
//                   </div>
                  
//                   <div>
//                     <label className="block text-sm font-medium text-gray-600 mb-1">Expected Return in Withdrawal Phase (% CAGR)</label>
//                     <input
//                       type="range"
//                       min="4"
//                       max="15"
//                       step="0.5"
//                       value={expectedReturnWithdrawal}
//                       onChange={(e) => setExpectedReturnWithdrawal(Number(e.target.value))}
//                       className="w-full accent-orange-500"
//                     />
//                     <div className="text-center font-bold text-orange-600 mt-1">{expectedReturnWithdrawal}%</div>
//                   </div>
                  
//                   <div>
//                     <label className="block text-sm font-medium text-gray-600 mb-1">Withdrawal Period (Years)</label>
//                     <input
//                       type="range"
//                       min="1"
//                       max="50"
//                       value={withdrawalPeriod}
//                       onChange={(e) => setWithdrawalPeriod(Number(e.target.value))}
//                       className="w-full accent-purple-500"
//                     />
//                     <div className="text-center font-bold text-purple-600 mt-1">{withdrawalPeriod} Years</div>
//                   </div>
//                 </>
//               )}
//             </div>
//           </div>
//         </div>

//         {/* Results Section */}
//         {result && (
//           <div className="space-y-5">
//             {/* Hero Result Card */}
//             <div className="bg-gradient-to-r from-[#2e56b8] to-[#4d7dff] rounded-2xl p-6 text-white">
//               <div className="flex items-center gap-3 mb-4">
//                 <div className="w-14 h-14 rounded-xl bg-white/20 flex items-center justify-center">
//                   <FaRocket className="text-2xl" />
//                 </div>
//                 <div>
//                   <p className="text-sm opacity-80">Total Corpus at Retirement</p>
//                   <h3 className="text-3xl font-bold">{formatLargeNumber(result.sipFV)}</h3>
//                 </div>
//               </div>
              
//               <div className="grid grid-cols-2 gap-4 mt-4">
//                 <div className="bg-white/10 rounded-xl p-3">
//                   <p className="text-xs opacity-80">Total Invested</p>
//                   <p className="text-xl font-bold">{formatLargeNumber(result.totalInvestedSIP)}</p>
//                 </div>
//                 <div className="bg-white/10 rounded-xl p-3">
//                   <p className="text-xs opacity-80">Wealth Generated</p>
//                   <p className="text-xl font-bold">{formatLargeNumber(result.totalReturnsSIP)}</p>
//                 </div>
//               </div>
//             </div>
            
//             {/* Summary Stats */}
//             <div className="grid grid-cols-2 gap-3">
//               <div className="bg-green-50 rounded-xl p-3 text-center">
//                 <p className="text-xs text-green-600 font-medium">Wealth Multiplier</p>
//                 <p className="text-xl font-bold text-green-700">{result.wealthMultiplier.toFixed(2)}x</p>
//               </div>
//               <div className="bg-blue-50 rounded-xl p-3 text-center">
//                 <p className="text-xs text-blue-600 font-medium">Monthly SIP (End)</p>
//                 <p className="text-xl font-bold text-blue-700">{formatCurrency(monthlySIP + (yearlyStepUp * sipTenure))}</p>
//               </div>
//             </div>
            
//             {immediateWithdrawal && (
//               <div className="bg-orange-50 rounded-xl p-4 border border-orange-100">
//                 <h5 className="font-bold text-orange-800 mb-3 flex items-center gap-2">
//                   <FaHandHoldingUsd /> Withdrawal Summary
//                 </h5>
//                 <div className="space-y-2 text-sm">
//                   <div className="flex justify-between">
//                     <span className="text-gray-600">Withdrawal Duration:</span>
//                     <span className="font-bold">{result.withdrawalYears} Years</span>
//                   </div>
//                   <div className="flex justify-between">
//                     <span className="text-gray-600">Total Withdrawn:</span>
//                     <span className="font-bold text-green-600">{formatLargeNumber(result.totalWithdrawn)}</span>
//                   </div>
//                   <div className="flex justify-between">
//                     <span className="text-gray-600">Remaining Corpus:</span>
//                     <span className="font-bold text-blue-600">{formatLargeNumber(result.finalCorpus)}</span>
//                   </div>
//                   <div className="flex justify-between">
//                     <span className="text-gray-600">Age Range:</span>
//                     <span className="font-bold">{result.withdrawalStartAge} - {result.withdrawalEndAge} Years</span>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </div>
//         )}
//       </div>

//       {/* Tabs for Charts */}
//       {chartData.length > 0 && (
//         <div className="mt-10">
//           <div className="flex gap-3 mb-5 border-b">
//             <button
//               onClick={() => setActiveTab('investment')}
//               className={`px-5 py-2 font-semibold transition-all ${activeTab === 'investment' ? 'border-b-2 border-blue-500 text-blue-600' : 'text-gray-500'}`}
//             >
//               <FaChartLine className="inline mr-2" /> Investment Growth
//             </button>
//             {immediateWithdrawal && withdrawalChartData.length > 0 && (
//               <button
//                 onClick={() => setActiveTab('withdrawal')}
//                 className={`px-5 py-2 font-semibold transition-all ${activeTab === 'withdrawal' ? 'border-b-2 border-orange-500 text-orange-600' : 'text-gray-500'}`}
//               >
//                 <FaHandHoldingUsd className="inline mr-2" /> Withdrawal Phase
//               </button>
//             )}
//             <button
//               onClick={() => setActiveTab('breakdown')}
//               className={`px-5 py-2 font-semibold transition-all ${activeTab === 'breakdown' ? 'border-b-2 border-green-500 text-green-600' : 'text-gray-500'}`}
//             >
//               <FaChartPie className="inline mr-2" /> Investment Breakdown
//             </button>
//           </div>
          
//           <div className="bg-gray-50 rounded-2xl p-5 h-[400px]">
//             {activeTab === 'investment' && (
//               <ResponsiveContainer width="100%" height="100%">
//                 <AreaChart data={chartData}>
//                   <defs>
//                     <linearGradient id="colorCorpus" x1="0" y1="0" x2="0" y2="1">
//                       <stop offset="5%" stopColor="#2e56b8" stopOpacity={0.8}/>
//                       <stop offset="95%" stopColor="#2e56b8" stopOpacity={0}/>
//                     </linearGradient>
//                   </defs>
//                   <CartesianGrid strokeDasharray="3 3" />
//                   <XAxis dataKey="year" label={{ value: 'Years', position: 'bottom' }} />
//                   <YAxis tickFormatter={(v) => formatLargeNumber(v)} />
//                   <Tooltip formatter={(v) => formatLargeNumber(v)} />
//                   <Legend />
//                   <Area type="monotone" dataKey="invested" stroke="#ff9800" fillOpacity={0.2} fill="#ff9800" name="Invested Amount" />
//                   <Area type="monotone" dataKey="sipValue" stroke="#2e56b8" fillOpacity={1} fill="url(#colorCorpus)" name="Portfolio Value" />
//                 </AreaChart>
//               </ResponsiveContainer>
//             )}
            
//             {activeTab === 'withdrawal' && withdrawalChartData.length > 0 && (
//               <ResponsiveContainer width="100%" height="100%">
//                 <LineChart data={withdrawalChartData}>
//                   <CartesianGrid strokeDasharray="3 3" />
//                   <XAxis dataKey="year" label={{ value: 'Withdrawal Years', position: 'bottom' }} />
//                   <YAxis tickFormatter={(v) => formatLargeNumber(v)} />
//                   <Tooltip formatter={(v) => formatLargeNumber(v)} />
//                   <Legend />
//                   <Line type="monotone" dataKey="balance" stroke="#2e56b8" name="Remaining Balance" strokeWidth={2} />
//                   <Line type="monotone" dataKey="cumulativeWithdrawn" stroke="#69bf74" name="Total Withdrawn" strokeWidth={2} />
//                 </LineChart>
//               </ResponsiveContainer>
//             )}
            
//             {activeTab === 'breakdown' && result && (
//               <ResponsiveContainer width="100%" height="100%">
//                 <PieChart>
//                   <Pie
//                     data={[
//                       { name: 'Total Invested', value: result.totalInvestedSIP },
//                       { name: 'Returns Generated', value: result.totalReturnsSIP },
//                     ]}
//                     cx="50%"
//                     cy="50%"
//                     outerRadius={120}
//                     dataKey="value"
//                     label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
//                   >
//                     <Cell fill="#2e56b8" />
//                     <Cell fill="#69bf74" />
//                   </Pie>
//                   <Tooltip formatter={(v) => formatLargeNumber(v)} />
//                   <Legend />
//                 </PieChart>
//               </ResponsiveContainer>
//             )}
//           </div>
//         </div>
//       )}

//       {/* Action Buttons */}
//       {result && (
//         <div className="grid md:grid-cols-2 gap-4 mt-8">
//           <button
//             onClick={() => setShowForm(true)}
//             className="flex items-center justify-center gap-3 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white py-4 rounded-xl font-semibold transition-all shadow-lg"
//           >
//             <FaFilePdf /> Download PDF Report
//           </button>
//           <button
//             onClick={() => setShowForm(true)}
//             className="flex items-center justify-center gap-3 bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white py-4 rounded-xl font-semibold transition-all shadow-lg"
//           >
//             <FaWhatsapp /> Share on WhatsApp
//           </button>
//         </div>
//       )}

//       {/* Hidden PDF Content */}
//       {result && (
//         <div id="advanced-result-content" style={{ display: 'none' }}>
//           <div style={{ padding: '30px', fontFamily: 'Arial' }}>
//             <div style={{ textAlign: 'center', borderBottom: '2px solid #1e3c72', paddingBottom: '20px', marginBottom: '20px' }}>
//               <h1 style={{ color: '#1e3c72' }}>Wisdom Consultancy</h1>
//               <p>E-44, Vasant Vihar Society, GIDC-Vadsar Road, Vadodara-390010</p>
//               <p>📞 9726344477 | ✉ wisdom2secure@gmail.com</p>
//               <h2 style={{ marginTop: '20px' }}>Advanced SIP Investment Report</h2>
//               {clientName && <h3>Client: {clientName}</h3>}
//             </div>
            
//             <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//               <tbody>
//                 <tr><td style={{ padding: '8px' }}><strong>Current Age</strong></td><td>{currentAge} Years</td></tr>
//                 <tr><td style={{ padding: '8px' }}><strong>SIP Tenure</strong></td><td>{sipTenure} Years</td></tr>
//                 <tr><td style={{ padding: '8px' }}><strong>Monthly SIP</strong></td><td>{formatCurrency(monthlySIP)}</td></tr>
//                 <tr><td style={{ padding: '8px' }}><strong>Yearly Step-Up</strong></td><td>{formatCurrency(yearlyStepUp)}</td></tr>
//                 <tr><td style={{ padding: '8px' }}><strong>Expected Return (SIP)</strong></td><td>{expectedReturnSIP}%</td></tr>
//                 <tr><td style={{ padding: '8px', background: '#f0f0f0' }}><strong>Total Invested</strong></td><td><strong>{formatLargeNumber(result.totalInvestedSIP)}</strong></td></tr>
//                 <tr><td style={{ padding: '8px', background: '#f0f0f0' }}><strong>Final Corpus</strong></td><td><strong>{formatLargeNumber(result.sipFV)}</strong></td></tr>
//                 <tr><td style={{ padding: '8px', background: '#f0f0f0' }}><strong>Wealth Generated</strong></td><td><strong>{formatLargeNumber(result.totalReturnsSIP)}</strong></td></tr>
//                 <tr><td style={{ padding: '8px', background: '#f0f0f0' }}><strong>Wealth Multiplier</strong></td><td><strong>{result.wealthMultiplier.toFixed(2)}x</strong></td></tr>
//               </tbody>
//             </table>
            
//             {immediateWithdrawal && (
//               <>
//                 <h3 style={{ marginTop: '20px' }}>Withdrawal Phase</h3>
//                 <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//                   <tbody>
//                     <tr><td style={{ padding: '8px' }}><strong>Monthly Withdrawal</strong></td><td>{formatCurrency(monthlyWithdrawal)}</td></tr>
//                     <tr><td style={{ padding: '8px' }}><strong>Withdrawal Duration</strong></td><td>{result.withdrawalYears} Years</td></tr>
//                     <tr><td style={{ padding: '8px' }}><strong>Total Withdrawn</strong></td><td>{formatLargeNumber(result.totalWithdrawn)}</td></tr>
//                     <tr><td style={{ padding: '8px' }}><strong>Remaining Corpus</strong></td><td>{formatLargeNumber(result.finalCorpus)}</td></tr>
//                   </tbody>
//                 </table>
//               </>
//             )}
            
//             <div style={{ marginTop: '30px', padding: '20px', background: '#f5f7fa', borderRadius: '10px' }}>
//               <h3>Disclaimer</h3>
//               <p style={{ fontSize: '12px' }}>Mutual Fund investments are subject to market risks. Read all scheme related documents carefully before investing. Past performance is not indicative of future returns.</p>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Form Modal */}
//       {showForm && (
//         <CalculatorForm
//           onSubmit={handleFormSubmit}
//           onClose={() => setShowForm(false)}
//           calculatorType="ComboCalculator"
//         />
//       )}
//     </motion.div>
//   );
// };

// export default ComboCalculator;

// import React, { useState, useEffect } from 'react';
// import {
//   PieChart,
//   Pie,
//   Cell,
//   ResponsiveContainer,
//   Legend,
//   Tooltip,
//   AreaChart,
//   Area,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   LineChart,
//   Line,
// } from 'recharts';
// import html2pdf from 'html2pdf.js';
// import { motion, AnimatePresence } from 'framer-motion';
// import {
//   FaChartLine,
//   FaWallet,
//   FaMoneyBillWave,
//   FaFilePdf,
//   FaWhatsapp,
//   FaShieldAlt,
//   FaBullseye,
//   FaRocket,
//   FaCalendarAlt,
//   FaPercentage,
//   FaStepForward,
//   FaHandHoldingUsd,
//   FaUserClock,
//   FaRupeeSign,
//   FaChartPie,
//   FaDownload,
//   FaShare,
//   FaCheckCircle,
//   FaArrowRight,
//   FaInfoCircle,
// } from 'react-icons/fa';

// import CalculatorForm from './CalculatorForm';

// const ComboCalculator = () => {
//   // Basic Details
//   const [clientName, setClientName] = useState('');
//   const [currentAge, setCurrentAge] = useState(30);
  
//   // SIP Phase Details
//   const [sipTenure, setSipTenure] = useState(20);
//   const [monthlySIP, setMonthlySIP] = useState(10000);
//   const [yearlyStepUp, setYearlyStepUp] = useState(10000);
//   const [expectedReturnSIP, setExpectedReturnSIP] = useState(12);
  
//   // Withdrawal Phase Details
//   const [immediateWithdrawal, setImmediateWithdrawal] = useState(true);
//   const [monthlyWithdrawal, setMonthlyWithdrawal] = useState(20000);
//   const [increaseWithdrawal, setIncreaseWithdrawal] = useState(true);
//   const [increasePercentage, setIncreasePercentage] = useState(5); // New: Increase percentage (0-10%)
//   const [expectedReturnWithdrawal, setExpectedReturnWithdrawal] = useState(8);
//   const [withdrawalPeriod, setWithdrawalPeriod] = useState(30);
  
//   const [result, setResult] = useState(null);
//   const [chartData, setChartData] = useState([]);
//   const [withdrawalChartData, setWithdrawalChartData] = useState([]);
//   const [showForm, setShowForm] = useState(false);
//   const [activeTab, setActiveTab] = useState('investment');

//   const COLORS = ['#2e56b8', '#69bf74', '#ff9800', '#f44336', '#9c27b0'];

//   // Calculate Withdrawal Start Age (Min = Current Age + SIP Tenure, Max = 100)
//   const withdrawalStartAgeMin = currentAge + sipTenure;
//   const withdrawalStartAge = withdrawalStartAgeMin;
//   const withdrawalStartAgeMax = 100;

//   const formatCurrency = (amount) => {
//     return `₹${Number(amount || 0).toLocaleString('en-IN', {
//       maximumFractionDigits: 0,
//     })}`;
//   };

//   const formatLargeNumber = (amount) => {
//     if (amount >= 10000000) {
//       return `₹${(amount / 10000000).toFixed(2)} Cr`;
//     }
//     if (amount >= 100000) {
//       return `₹${(amount / 100000).toFixed(2)} L`;
//     }
//     return formatCurrency(amount);
//   };

//   const calculate = () => {
//     // SIP Phase Calculations
//     const monthlyRateSIP = expectedReturnSIP / 12 / 100;
//     const totalMonths = sipTenure * 12;
    
//     let sipFV = 0;
//     let sipContributions = [];
//     let yearlyData = [];
//     let currentSIP = monthlySIP;
    
//     for (let month = 1; month <= totalMonths; month++) {
//       sipFV = (sipFV + currentSIP) * (1 + monthlyRateSIP);
      
//       // Apply step-up at the beginning of each year
//       if (month % 12 === 0 && month < totalMonths) {
//         currentSIP += yearlyStepUp;
//       }
      
//       if (month % 12 === 0) {
//         const year = month / 12;
//         yearlyData.push({
//           year,
//           sipValue: sipFV,
//           invested: (() => {
//             let total = 0;
//             let sip = monthlySIP;
//             for (let y = 1; y <= year; y++) {
//               total += sip * 12;
//               if (y < year) sip += yearlyStepUp;
//             }
//             return total;
//           })(),
//         });
//       }
//     }
    
//     const totalInvestedSIP = (() => {
//       let total = 0;
//       let sip = monthlySIP;
//       for (let i = 0; i < sipTenure; i++) {
//         total += sip * 12;
//         sip += yearlyStepUp;
//       }
//       return total;
//     })();
    
//     const totalReturnsSIP = sipFV - totalInvestedSIP;
    
//     // Withdrawal Phase Calculations
//     let withdrawalBalance = sipFV;
//     const monthlyRateWithdrawal = expectedReturnWithdrawal / 12 / 100;
//     let currentWithdrawal = monthlyWithdrawal;
//     let totalWithdrawn = 0;
//     let withdrawalYears = 0;
//     let withdrawalData = [];
//     let monthsWithdrawn = 0;
    
//     if (immediateWithdrawal) {
//       while (withdrawalBalance > 0 && withdrawalYears < withdrawalPeriod) {
//         let yearWithdrawal = 0;
//         let yearlyWithdrawn = 0;
        
//         for (let month = 1; month <= 12; month++) {
//           if (withdrawalBalance <= 0) break;
          
//           withdrawalBalance = withdrawalBalance * (1 + monthlyRateWithdrawal) - currentWithdrawal;
//           totalWithdrawn += currentWithdrawal;
//           yearlyWithdrawn += currentWithdrawal;
//           monthsWithdrawn++;
          
//           if (withdrawalBalance <= 0) break;
//         }
        
//         withdrawalYears++;
//         withdrawalData.push({
//           year: withdrawalYears,
//           balance: Math.max(0, withdrawalBalance),
//           withdrawn: yearlyWithdrawn,
//           cumulativeWithdrawn: totalWithdrawn,
//         });
        
//         // Use the percentage from increasePercentage (0-10%)
//         if (increaseWithdrawal && withdrawalBalance > 0) {
//           currentWithdrawal = currentWithdrawal * (1 + (increasePercentage / 100));
//         }
        
//         if (withdrawalBalance <= 0) break;
//       }
//     }
    
//     const withdrawalEndAge = Math.min(withdrawalStartAge + withdrawalYears, 100);
    
//     setResult({
//       sipFV,
//       totalInvestedSIP,
//       totalReturnsSIP,
//       wealthMultiplier: sipFV / totalInvestedSIP,
//       withdrawalBalance: Math.max(0, withdrawalBalance),
//       totalWithdrawn,
//       withdrawalYears,
//       withdrawalStartAge,
//       withdrawalEndAge,
//       finalCorpus: Math.max(0, withdrawalBalance),
//       monthlyWithdrawalEnd: currentWithdrawal,
//     });
    
//     setChartData(yearlyData);
//     setWithdrawalChartData(withdrawalData);
//   };

//   useEffect(() => {
//     calculate();
//   }, [sipTenure, monthlySIP, yearlyStepUp, expectedReturnSIP, 
//       immediateWithdrawal, monthlyWithdrawal, increaseWithdrawal, increasePercentage,
//       expectedReturnWithdrawal, withdrawalPeriod, currentAge]);

//   const handleFormSubmit = (userData) => {
//     const element = document.getElementById('advanced-result-content');
    
//     html2pdf()
//       .set({
//         margin: 0.5,
//         filename: `SIP_Plan_${userData.name || clientName || 'Report'}.pdf`,
//         image: { type: 'jpeg', quality: 1 },
//         html2canvas: { scale: 2 },
//         jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
//       })
//       .from(element)
//       .save();
    
//     setShowForm(false);
    
//     const whatsappMessage = `🏦 *Advanced SIP Investment Report*

// 👤 Client: ${userData.name || clientName || 'Investor'}

// 📊 *Investment Phase*
// 💰 Monthly SIP: ${formatCurrency(monthlySIP)}
// 📈 Yearly Step-Up: ${formatCurrency(yearlyStepUp)}
// ⏱️ SIP Tenure: ${sipTenure} Years
// 📊 Expected Return: ${expectedReturnSIP}%

// 💎 *Results*
// ✅ Total Invested: ${formatCurrency(result?.totalInvestedSIP)}
// 🚀 Final Corpus: ${formatCurrency(result?.sipFV)}
// 📈 Wealth Generated: ${formatCurrency(result?.totalReturnsSIP)}
// ⚡ Wealth Multiplier: ${result?.wealthMultiplier?.toFixed(2)}x

// ${immediateWithdrawal ? `
// 🔄 *Withdrawal Phase*
// 💸 Monthly Withdrawal: ${formatCurrency(monthlyWithdrawal)}
// 📈 Withdrawal Return: ${expectedReturnWithdrawal}%
// 📅 Withdrawal Duration: ${result?.withdrawalYears} Years
// 💰 Total Withdrawn: ${formatCurrency(result?.totalWithdrawn)}
// 🏦 Remaining Corpus: ${formatCurrency(result?.finalCorpus)}
// ${increaseWithdrawal ? `📈 Annual Increase: ${increasePercentage}%` : ''}
// ` : ''}

// ---
// *Wisdom Consultancy*
// 📞 9726344477
// 📧 wisdom2secure@gmail.com`;

//     window.open(`https://wa.me/${userData.phone}?text=${encodeURIComponent(whatsappMessage)}`, '_blank');
//   };

//   return (
//     <motion.div
//       initial={{ opacity: 0, y: 20 }}
//       animate={{ opacity: 1, y: 0 }}
//       className="bg-white rounded-[32px] shadow-2xl border border-gray-100 p-6 md:p-8"
//     >
//       {/* Header */}
//       <div className="mb-8">
//         <div className="inline-flex items-center gap-3 bg-gradient-to-r from-blue-50 to-indigo-50 px-5 py-3 rounded-full mb-5">
//           <div className="w-11 h-11 rounded-full bg-gradient-to-r from-[#2e56b8] to-[#4d7dff] flex items-center justify-center text-white">
//             <FaChartLine />
//           </div>
//           <span className="font-semibold text-gray-700">Advanced SIP + SWP Planning</span>
//         </div>
        
//         <h3 className="text-3xl font-bold text-gray-800 mb-3">
//           Smart Investment & Withdrawal Planner
//         </h3>
        
//         <p className="text-gray-500 leading-relaxed">
//           Plan your wealth creation with SIP, step-up investments, and systematic withdrawal strategy
//         </p>
//       </div>

//       {/* Main Grid */}
//       <div className="grid lg:grid-cols-2 gap-8">
//         {/* Input Section */}
//         <div className="space-y-6">
//           {/* Client Details */}
//           <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl p-5">
//             <h4 className="font-bold text-gray-700 mb-4 flex items-center gap-2">
//               <FaUserClock /> Client Details
//             </h4>
//             <div className="grid grid-cols-2 gap-4">
//               <div>
//                 <label className="block text-sm font-medium text-gray-600 mb-1">Client Name</label>
//                 <input
//                   type="text"
//                   value={clientName}
//                   onChange={(e) => setClientName(e.target.value)}
//                   placeholder="Enter name"
//                   className="w-full border border-gray-200 rounded-xl px-4 py-2 outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600 mb-1">Current Age (Years)</label>
//                 <input
//                   type="number"
//                   value={currentAge}
//                   onChange={(e) => setCurrentAge(Number(e.target.value))}
//                   className="w-full border border-gray-200 rounded-xl px-4 py-2 outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Investment Phase */}
//           <div className="bg-white border border-gray-100 rounded-2xl p-5 shadow-sm">
//             <h4 className="font-bold text-gray-700 mb-4 flex items-center gap-2">
//               <FaRupeeSign className="text-green-500" /> Investment Phase (SIP)
//             </h4>
            
//             <div className="space-y-4">
//               <div>
//                 <label className="block text-sm font-medium text-gray-600 mb-1">SIP Tenure (Years)</label>
//                 <input
//                   type="range"
//                   min="1"
//                   max="50"
//                   value={sipTenure}
//                   onChange={(e) => setSipTenure(Number(e.target.value))}
//                   className="w-full accent-blue-500"
//                 />
//                 <div className="text-center font-bold text-blue-600 mt-1">{sipTenure} Years</div>
//               </div>
              
//               <div>
//                 <label className="block text-sm font-medium text-gray-600 mb-1">Monthly SIP Amount (₹)</label>
//                 <input
//                   type="number"
//                   value={monthlySIP}
//                   onChange={(e) => setMonthlySIP(Number(e.target.value))}
//                   className="w-full border border-gray-200 rounded-xl px-4 py-2 outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
              
//               <div>
//                 <label className="block text-sm font-medium text-gray-600 mb-1">Yearly Step-Up SIP Amount (₹)</label>
//                 <input
//                   type="number"
//                   value={yearlyStepUp}
//                   onChange={(e) => setYearlyStepUp(Number(e.target.value))}
//                   className="w-full border border-gray-200 rounded-xl px-4 py-2 outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
              
//               <div>
//                 <label className="block text-sm font-medium text-gray-600 mb-1">Expected Return from SIP (% CAGR)</label>
//                 <input
//                   type="range"
//                   min="4"
//                   max="20"
//                   step="0.5"
//                   value={expectedReturnSIP}
//                   onChange={(e) => setExpectedReturnSIP(Number(e.target.value))}
//                   className="w-full accent-green-500"
//                 />
//                 <div className="text-center font-bold text-green-600 mt-1">{expectedReturnSIP}%</div>
//               </div>
//             </div>
//           </div>

//           {/* Withdrawal Phase - UPDATED SECTION */}
//           <div className="bg-white border border-gray-100 rounded-2xl p-5 shadow-sm">
//             <h4 className="font-bold text-gray-700 mb-4 flex items-center gap-2">
//               <FaHandHoldingUsd className="text-orange-500" /> Withdrawal Phase (SWP)
//             </h4>
            
//             <div className="space-y-4">
//               {/* Immediate Withdrawal after SIP Tenure - Yes/No Toggle */}
//               <div>
//                 <label className="block text-sm font-medium text-gray-600 mb-2">Immediate Withdrawal after SIP Tenure</label>
//                 <div className="flex gap-4">
//                   <button
//                     onClick={() => setImmediateWithdrawal(true)}
//                     className={`px-6 py-2 rounded-xl font-semibold transition-all ${immediateWithdrawal ? 'bg-green-500 text-white' : 'bg-gray-100 text-gray-600'}`}
//                   >
//                     Yes
//                   </button>
//                   <button
//                     onClick={() => setImmediateWithdrawal(false)}
//                     className={`px-6 py-2 rounded-xl font-semibold transition-all ${!immediateWithdrawal ? 'bg-red-500 text-white' : 'bg-gray-100 text-gray-600'}`}
//                   >
//                     No
//                   </button>
//                 </div>
//               </div>
              
//               {immediateWithdrawal && (
//                 <>
//                   {/* Withdrawal Start Age - Display Only (Calculated) */}
//                   <div className="bg-gray-50 rounded-xl p-3">
//                     <label className="block text-sm font-medium text-gray-600 mb-1">Withdrawal Start Age (Years)</label>
//                     <div className="flex items-center gap-2">
//                       <input
//                         type="number"
//                         value={withdrawalStartAge}
//                         readOnly
//                         disabled
//                         className="w-full border border-gray-200 rounded-xl px-4 py-2 bg-gray-100 text-gray-700 font-semibold"
//                       />
//                       <span className="text-xs text-gray-500 whitespace-nowrap">Min: {withdrawalStartAgeMin} | Max: 100</span>
//                     </div>
//                     <p className="text-xs text-gray-400 mt-1">*Calculated as Current Age + SIP Tenure</p>
//                   </div>
                  
//                   {/* Monthly Withdrawal Amount */}
//                   <div>
//                     <label className="block text-sm font-medium text-gray-600 mb-1">Monthly Withdrawal Amount (₹)</label>
//                     <input
//                       type="number"
//                       value={monthlyWithdrawal}
//                       onChange={(e) => setMonthlyWithdrawal(Number(e.target.value))}
//                       className="w-full border border-gray-200 rounded-xl px-4 py-2 outline-none focus:ring-2 focus:ring-blue-500"
//                     />
//                   </div>
                  
//                   {/* Increase in Withdrawal Amount every Year - Yes/No Toggle */}
//                   <div>
//                     <label className="block text-sm font-medium text-gray-600 mb-2">Increase in Withdrawal Amount every Year</label>
//                     <div className="flex gap-4">
//                       <button
//                         onClick={() => setIncreaseWithdrawal(true)}
//                         className={`px-6 py-2 rounded-xl font-semibold transition-all ${increaseWithdrawal ? 'bg-green-500 text-white' : 'bg-gray-100 text-gray-600'}`}
//                       >
//                         Yes
//                       </button>
//                       <button
//                         onClick={() => setIncreaseWithdrawal(false)}
//                         className={`px-6 py-2 rounded-xl font-semibold transition-all ${!increaseWithdrawal ? 'bg-red-500 text-white' : 'bg-gray-100 text-gray-600'}`}
//                       >
//                         No
//                       </button>
//                     </div>
//                   </div>
                  
//                   {/* Assumed Increase (%) - Only show if Increase Withdrawal is Yes */}
//                   {increaseWithdrawal && (
//                     <div>
//                       <label className="block text-sm font-medium text-gray-600 mb-1">Assumed Increase (%)</label>
//                       <div className="flex items-center gap-3">
//                         <input
//                           type="range"
//                           min="0"
//                           max="10"
//                           step="0.5"
//                           value={increasePercentage}
//                           onChange={(e) => setIncreasePercentage(Number(e.target.value))}
//                           className="flex-1 accent-orange-500"
//                         />
//                         <span className="w-16 text-center font-bold text-orange-600 bg-orange-50 px-3 py-1 rounded-full">
//                           {increasePercentage}%
//                         </span>
//                       </div>
//                       <p className="text-xs text-gray-400 mt-1">Min 0% - Max 10%</p>
//                     </div>
//                   )}
                  
//                   {/* Expected Return in Withdrawal Phase */}
//                   <div>
//                     <label className="block text-sm font-medium text-gray-600 mb-1">Expected Return in Withdrawal Phase (% CAGR)</label>
//                     <input
//                       type="range"
//                       min="4"
//                       max="15"
//                       step="0.5"
//                       value={expectedReturnWithdrawal}
//                       onChange={(e) => setExpectedReturnWithdrawal(Number(e.target.value))}
//                       className="w-full accent-orange-500"
//                     />
//                     <div className="text-center font-bold text-orange-600 mt-1">{expectedReturnWithdrawal}%</div>
//                   </div>
                  
//                   {/* Withdrawal Period */}
//                   <div>
//                     <label className="block text-sm font-medium text-gray-600 mb-1">Withdrawal Period (Years)</label>
//                     <input
//                       type="range"
//                       min="1"
//                       max="50"
//                       value={withdrawalPeriod}
//                       onChange={(e) => setWithdrawalPeriod(Number(e.target.value))}
//                       className="w-full accent-purple-500"
//                     />
//                     <div className="text-center font-bold text-purple-600 mt-1">{withdrawalPeriod} Years</div>
//                   </div>
//                 </>
//               )}
//             </div>
//           </div>
//         </div>

//         {/* Results Section */}
//         {result && (
//           <div className="space-y-5">
//             {/* Hero Result Card */}
//             <div className="bg-gradient-to-r from-[#2e56b8] to-[#4d7dff] rounded-2xl p-6 text-white">
//               <div className="flex items-center gap-3 mb-4">
//                 <div className="w-14 h-14 rounded-xl bg-white/20 flex items-center justify-center">
//                   <FaRocket className="text-2xl" />
//                 </div>
//                 <div>
//                   <p className="text-sm opacity-80">Total Corpus at Retirement</p>
//                   <h3 className="text-3xl font-bold">{formatLargeNumber(result.sipFV)}</h3>
//                 </div>
//               </div>
              
//               <div className="grid grid-cols-2 gap-4 mt-4">
//                 <div className="bg-white/10 rounded-xl p-3">
//                   <p className="text-xs opacity-80">Total Invested</p>
//                   <p className="text-xl font-bold">{formatLargeNumber(result.totalInvestedSIP)}</p>
//                 </div>
//                 <div className="bg-white/10 rounded-xl p-3">
//                   <p className="text-xs opacity-80">Wealth Generated</p>
//                   <p className="text-xl font-bold">{formatLargeNumber(result.totalReturnsSIP)}</p>
//                 </div>
//               </div>
//             </div>
            
//             {/* Summary Stats */}
//             <div className="grid grid-cols-2 gap-3">
//               <div className="bg-green-50 rounded-xl p-3 text-center">
//                 <p className="text-xs text-green-600 font-medium">Wealth Multiplier</p>
//                 <p className="text-xl font-bold text-green-700">{result.wealthMultiplier.toFixed(2)}x</p>
//               </div>
//               <div className="bg-blue-50 rounded-xl p-3 text-center">
//                 <p className="text-xs text-blue-600 font-medium">Monthly SIP (End)</p>
//                 <p className="text-xl font-bold text-blue-700">{formatCurrency(monthlySIP + (yearlyStepUp * sipTenure))}</p>
//               </div>
//             </div>
            
//             {immediateWithdrawal && (
//               <div className="bg-orange-50 rounded-xl p-4 border border-orange-100">
//                 <h5 className="font-bold text-orange-800 mb-3 flex items-center gap-2">
//                   <FaHandHoldingUsd /> Withdrawal Summary
//                 </h5>
//                 <div className="space-y-2 text-sm">
//                   <div className="flex justify-between">
//                     <span className="text-gray-600">Withdrawal Start Age:</span>
//                     <span className="font-bold">{result.withdrawalStartAge} Years</span>
//                   </div>
//                   <div className="flex justify-between">
//                     <span className="text-gray-600">Withdrawal Duration:</span>
//                     <span className="font-bold">{result.withdrawalYears} Years</span>
//                   </div>
//                   <div className="flex justify-between">
//                     <span className="text-gray-600">Total Withdrawn:</span>
//                     <span className="font-bold text-green-600">{formatLargeNumber(result.totalWithdrawn)}</span>
//                   </div>
//                   <div className="flex justify-between">
//                     <span className="text-gray-600">Remaining Corpus:</span>
//                     <span className="font-bold text-blue-600">{formatLargeNumber(result.finalCorpus)}</span>
//                   </div>
//                   <div className="flex justify-between">
//                     <span className="text-gray-600">Age Range:</span>
//                     <span className="font-bold">{result.withdrawalStartAge} - {result.withdrawalEndAge} Years</span>
//                   </div>
//                   {increaseWithdrawal && (
//                     <div className="flex justify-between">
//                       <span className="text-gray-600">Annual Increase:</span>
//                       <span className="font-bold text-orange-600">{increasePercentage}%</span>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             )}
//           </div>
//         )}
//       </div>

//       {/* Tabs for Charts */}
//       {chartData.length > 0 && (
//         <div className="mt-10">
//           <div className="flex gap-3 mb-5 border-b">
//             <button
//               onClick={() => setActiveTab('investment')}
//               className={`px-5 py-2 font-semibold transition-all ${activeTab === 'investment' ? 'border-b-2 border-blue-500 text-blue-600' : 'text-gray-500'}`}
//             >
//               <FaChartLine className="inline mr-2" /> Investment Growth
//             </button>
//             {immediateWithdrawal && withdrawalChartData.length > 0 && (
//               <button
//                 onClick={() => setActiveTab('withdrawal')}
//                 className={`px-5 py-2 font-semibold transition-all ${activeTab === 'withdrawal' ? 'border-b-2 border-orange-500 text-orange-600' : 'text-gray-500'}`}
//               >
//                 <FaHandHoldingUsd className="inline mr-2" /> Withdrawal Phase
//               </button>
//             )}
//             <button
//               onClick={() => setActiveTab('breakdown')}
//               className={`px-5 py-2 font-semibold transition-all ${activeTab === 'breakdown' ? 'border-b-2 border-green-500 text-green-600' : 'text-gray-500'}`}
//             >
//               <FaChartPie className="inline mr-2" /> Investment Breakdown
//             </button>
//           </div>
          
//           <div className="bg-gray-50 rounded-2xl p-5 h-[400px]">
//             {activeTab === 'investment' && (
//               <ResponsiveContainer width="100%" height="100%">
//                 <AreaChart data={chartData}>
//                   <defs>
//                     <linearGradient id="colorCorpus" x1="0" y1="0" x2="0" y2="1">
//                       <stop offset="5%" stopColor="#2e56b8" stopOpacity={0.8}/>
//                       <stop offset="95%" stopColor="#2e56b8" stopOpacity={0}/>
//                     </linearGradient>
//                   </defs>
//                   <CartesianGrid strokeDasharray="3 3" />
//                   <XAxis dataKey="year" label={{ value: 'Years', position: 'bottom' }} />
//                   <YAxis tickFormatter={(v) => formatLargeNumber(v)} />
//                   <Tooltip formatter={(v) => formatLargeNumber(v)} />
//                   <Legend />
//                   <Area type="monotone" dataKey="invested" stroke="#ff9800" fillOpacity={0.2} fill="#ff9800" name="Invested Amount" />
//                   <Area type="monotone" dataKey="sipValue" stroke="#2e56b8" fillOpacity={1} fill="url(#colorCorpus)" name="Portfolio Value" />
//                 </AreaChart>
//               </ResponsiveContainer>
//             )}
            
//             {activeTab === 'withdrawal' && withdrawalChartData.length > 0 && (
//               <ResponsiveContainer width="100%" height="100%">
//                 <LineChart data={withdrawalChartData}>
//                   <CartesianGrid strokeDasharray="3 3" />
//                   <XAxis dataKey="year" label={{ value: 'Withdrawal Years', position: 'bottom' }} />
//                   <YAxis tickFormatter={(v) => formatLargeNumber(v)} />
//                   <Tooltip formatter={(v) => formatLargeNumber(v)} />
//                   <Legend />
//                   <Line type="monotone" dataKey="balance" stroke="#2e56b8" name="Remaining Balance" strokeWidth={2} />
//                   <Line type="monotone" dataKey="cumulativeWithdrawn" stroke="#69bf74" name="Total Withdrawn" strokeWidth={2} />
//                 </LineChart>
//               </ResponsiveContainer>
//             )}
            
//             {activeTab === 'breakdown' && result && (
//               <ResponsiveContainer width="100%" height="100%">
//                 <PieChart>
//                   <Pie
//                     data={[
//                       { name: 'Total Invested', value: result.totalInvestedSIP },
//                       { name: 'Returns Generated', value: result.totalReturnsSIP },
//                     ]}
//                     cx="50%"
//                     cy="50%"
//                     outerRadius={120}
//                     dataKey="value"
//                     label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
//                   >
//                     <Cell fill="#2e56b8" />
//                     <Cell fill="#69bf74" />
//                   </Pie>
//                   <Tooltip formatter={(v) => formatLargeNumber(v)} />
//                   <Legend />
//                 </PieChart>
//               </ResponsiveContainer>
//             )}
//           </div>
//         </div>
//       )}

//       {/* Action Buttons */}
//       {result && (
//         <div className="grid md:grid-cols-2 gap-4 mt-8">
//           <button
//             onClick={() => setShowForm(true)}
//             className="flex items-center justify-center gap-3 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white py-4 rounded-xl font-semibold transition-all shadow-lg"
//           >
//             <FaFilePdf /> Download PDF Report
//           </button>
//           <button
//             onClick={() => setShowForm(true)}
//             className="flex items-center justify-center gap-3 bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white py-4 rounded-xl font-semibold transition-all shadow-lg"
//           >
//             <FaWhatsapp /> Share on WhatsApp
//           </button>
//         </div>
//       )}

//       {/* Hidden PDF Content */}
//       {result && (
//         <div id="advanced-result-content" style={{ display: 'none' }}>
//           <div style={{ padding: '30px', fontFamily: 'Arial' }}>
//             <div style={{ textAlign: 'center', borderBottom: '2px solid #1e3c72', paddingBottom: '20px', marginBottom: '20px' }}>
//               <h1 style={{ color: '#1e3c72' }}>Wisdom Consultancy</h1>
//               <p>E-44, Vasant Vihar Society, GIDC-Vadsar Road, Vadodara-390010</p>
//               <p>📞 9726344477 | ✉ wisdom2secure@gmail.com</p>
//               <h2 style={{ marginTop: '20px' }}>Advanced SIP Investment Report</h2>
//               {clientName && <h3>Client: {clientName}</h3>}
//             </div>
            
//             <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//               <tbody>
//                 <tr><td style={{ padding: '8px' }}><strong>Current Age</strong></td><td>{currentAge} Years</td></tr>
//                 <tr><td style={{ padding: '8px' }}><strong>SIP Tenure</strong></td><td>{sipTenure} Years</td></tr>
//                 <tr><td style={{ padding: '8px' }}><strong>Monthly SIP</strong></td><td>{formatCurrency(monthlySIP)}</td></tr>
//                 <tr><td style={{ padding: '8px' }}><strong>Yearly Step-Up</strong></td><td>{formatCurrency(yearlyStepUp)}</td></tr>
//                 <tr><td style={{ padding: '8px' }}><strong>Expected Return (SIP)</strong></td><td>{expectedReturnSIP}%</td></tr>
//                 <tr><td style={{ padding: '8px', background: '#f0f0f0' }}><strong>Total Invested</strong></td><td><strong>{formatLargeNumber(result.totalInvestedSIP)}</strong></td></tr>
//                 <tr><td style={{ padding: '8px', background: '#f0f0f0' }}><strong>Final Corpus</strong></td><td><strong>{formatLargeNumber(result.sipFV)}</strong></td></tr>
//                 <tr><td style={{ padding: '8px', background: '#f0f0f0' }}><strong>Wealth Generated</strong></td><td><strong>{formatLargeNumber(result.totalReturnsSIP)}</strong></td></tr>
//                 <tr><td style={{ padding: '8px', background: '#f0f0f0' }}><strong>Wealth Multiplier</strong></td><td><strong>{result.wealthMultiplier.toFixed(2)}x</strong></td></tr>
//               </tbody>
//             </table>
            
//             {immediateWithdrawal && (
//               <>
//                 <h3 style={{ marginTop: '20px' }}>Withdrawal Phase</h3>
//                 <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//                   <tbody>
//                     <tr><td style={{ padding: '8px' }}><strong>Withdrawal Start Age</strong></td><td>{result.withdrawalStartAge} Years</td></tr>
//                     <tr><td style={{ padding: '8px' }}><strong>Monthly Withdrawal</strong></td><td>{formatCurrency(monthlyWithdrawal)}</td></tr>
//                     <tr><td style={{ padding: '8px' }}><strong>Withdrawal Duration</strong></td><td>{result.withdrawalYears} Years</td></tr>
//                     <tr><td style={{ padding: '8px' }}><strong>Total Withdrawn</strong></td><td>{formatLargeNumber(result.totalWithdrawn)}</td></tr>
//                     <tr><td style={{ padding: '8px' }}><strong>Remaining Corpus</strong></td><td>{formatLargeNumber(result.finalCorpus)}</td></tr>
//                     {increaseWithdrawal && <tr><td style={{ padding: '8px' }}><strong>Annual Increase</strong></td><td>{increasePercentage}%</td></tr>}
//                   </tbody>
//                 </table>
//               </>
//             )}
            
//             <div style={{ marginTop: '30px', padding: '20px', background: '#f5f7fa', borderRadius: '10px' }}>
//               <h3>Disclaimer</h3>
//               <p style={{ fontSize: '12px' }}>Mutual Fund investments are subject to market risks. Read all scheme related documents carefully before investing. Past performance is not indicative of future returns.</p>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Form Modal */}
//       {showForm && (
//         <CalculatorForm
//           onSubmit={handleFormSubmit}
//           onClose={() => setShowForm(false)}
//           calculatorType="ComboCalculator"
//         />
//       )}
//     </motion.div>
//   );
// };

// export default ComboCalculator;

import React, { useState, useEffect } from 'react';
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Legend,
  Tooltip,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  LineChart,
  Line,
} from 'recharts';
// import html2pdf from 'html2pdf.js';
import { motion } from 'framer-motion';
import {
  FaChartLine,
  FaWallet,
  FaMoneyBillWave,
  FaFilePdf,
  FaWhatsapp,
  FaShieldAlt,
  FaBullseye,
  FaRocket,
  FaCalendarAlt,
  FaPercentage,
  FaStepForward,
  FaHandHoldingUsd,
  FaUserClock,
  FaRupeeSign,
  FaChartPie,
  FaDownload,
  FaShare,
  FaCheckCircle,
  FaArrowRight,
} from 'react-icons/fa';

import CalculatorForm from './CalculatorForm';

const ComboCalculator = () => {
  // Basic Details
  const [clientName, setClientName] = useState('');
  const [currentAge, setCurrentAge] = useState(30);
  
  // SIP Phase Details
  const [sipTenure, setSipTenure] = useState(20);
  const [monthlySIP, setMonthlySIP] = useState(10000);
  const [yearlyStepUp, setYearlyStepUp] = useState(10000);
  const [expectedReturnSIP, setExpectedReturnSIP] = useState(12);
  
  // Withdrawal Phase Details
  const [immediateWithdrawal, setImmediateWithdrawal] = useState(true);
  const [customWithdrawalStartAge, setCustomWithdrawalStartAge] = useState(60); // For delayed withdrawal
  const [monthlyWithdrawal, setMonthlyWithdrawal] = useState(20000);
  const [increaseWithdrawal, setIncreaseWithdrawal] = useState(true);
  const [increasePercentage, setIncreasePercentage] = useState(5);
  const [expectedReturnWithdrawal, setExpectedReturnWithdrawal] = useState(8);
  const [withdrawalPeriod, setWithdrawalPeriod] = useState(30);
  
  const [result, setResult] = useState(null);
  const [chartData, setChartData] = useState([]);
  const [withdrawalChartData, setWithdrawalChartData] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [activeTab, setActiveTab] = useState('investment');

  const COLORS = ['#2e56b8', '#69bf74', '#ff9800', '#f44336', '#9c27b0'];

  // Calculate withdrawal start age based on selection
  const calculatedWithdrawalStartAge = currentAge + sipTenure;
  const withdrawalStartAge = immediateWithdrawal ? calculatedWithdrawalStartAge : customWithdrawalStartAge;

  const formatCurrency = (amount) => {
    return `₹${Number(amount || 0).toLocaleString('en-IN', {
      maximumFractionDigits: 0,
    })}`;
  };

  const formatLargeNumber = (amount) => {
    if (amount >= 10000000) {
      return `₹${(amount / 10000000).toFixed(2)} Cr`;
    }
    if (amount >= 100000) {
      return `₹${(amount / 100000).toFixed(2)} L`;
    }
    return formatCurrency(amount);
  };

  const calculate = () => {
    // SIP Phase Calculations
    const monthlyRateSIP = expectedReturnSIP / 12 / 100;
    const totalMonths = sipTenure * 12;
    
    let sipFV = 0;
    let yearlyData = [];
    let currentSIP = monthlySIP;
    
    for (let month = 1; month <= totalMonths; month++) {
      sipFV = (sipFV + currentSIP) * (1 + monthlyRateSIP);
      
      if (month % 12 === 0 && month < totalMonths) {
        currentSIP += yearlyStepUp;
      }
      
      if (month % 12 === 0) {
        const year = month / 12;
        yearlyData.push({
          year,
          sipValue: sipFV,
          invested: (() => {
            let total = 0;
            let sip = monthlySIP;
            for (let y = 1; y <= year; y++) {
              total += sip * 12;
              if (y < year) sip += yearlyStepUp;
            }
            return total;
          })(),
        });
      }
    }
    
    const totalInvestedSIP = (() => {
      let total = 0;
      let sip = monthlySIP;
      for (let i = 0; i < sipTenure; i++) {
        total += sip * 12;
        sip += yearlyStepUp;
      }
      return total;
    })();
    
    const totalReturnsSIP = sipFV - totalInvestedSIP;
    
    // Handle growth between SIP end and withdrawal start (if delayed)
    let corpusAtWithdrawalStart = sipFV;
    const yearsBetween = Math.max(0, withdrawalStartAge - (currentAge + sipTenure));
    
    if (yearsBetween > 0) {
      const annualRate = expectedReturnWithdrawal / 100;
      corpusAtWithdrawalStart = sipFV * Math.pow(1 + annualRate, yearsBetween);
    }
    
    // Withdrawal Phase Calculations
    let withdrawalBalance = corpusAtWithdrawalStart;
    const monthlyRateWithdrawal = expectedReturnWithdrawal / 12 / 100;
    let currentWithdrawal = monthlyWithdrawal;
    let totalWithdrawn = 0;
    let withdrawalYears = 0;
    let withdrawalData = [];
    
    if (immediateWithdrawal || yearsBetween >= 0) {
      while (withdrawalBalance > 0 && withdrawalYears < withdrawalPeriod) {
        let yearlyWithdrawn = 0;
        
        for (let month = 1; month <= 12; month++) {
          if (withdrawalBalance <= 0) break;
          
          withdrawalBalance = withdrawalBalance * (1 + monthlyRateWithdrawal) - currentWithdrawal;
          totalWithdrawn += currentWithdrawal;
          yearlyWithdrawn += currentWithdrawal;
          
          if (withdrawalBalance <= 0) break;
        }
        
        withdrawalYears++;
        withdrawalData.push({
          year: withdrawalYears,
          balance: Math.max(0, withdrawalBalance),
          withdrawn: yearlyWithdrawn,
          cumulativeWithdrawn: totalWithdrawn,
        });
        
        if (increaseWithdrawal && withdrawalBalance > 0) {
          currentWithdrawal = currentWithdrawal * (1 + (increasePercentage / 100));
        }
        
        if (withdrawalBalance <= 0) break;
      }
    }
    
    const withdrawalEndAge = Math.min(withdrawalStartAge + withdrawalYears, 100);
    
    setResult({
      sipFV,
      totalInvestedSIP,
      totalReturnsSIP,
      wealthMultiplier: sipFV / totalInvestedSIP,
      withdrawalBalance: Math.max(0, withdrawalBalance),
      totalWithdrawn,
      withdrawalYears,
      withdrawalStartAge,
      withdrawalEndAge,
      finalCorpus: Math.max(0, withdrawalBalance),
      monthlyWithdrawalEnd: currentWithdrawal,
      corpusAtWithdrawalStart,
      yearsBetween,
    });
    
    setChartData(yearlyData);
    setWithdrawalChartData(withdrawalData);
  };

  // useEffect(() => {
  //   calculate();
  // }, [sipTenure, monthlySIP, yearlyStepUp, expectedReturnSIP, 
  //     immediateWithdrawal, customWithdrawalStartAge, monthlyWithdrawal, 
  //     increaseWithdrawal, increasePercentage, expectedReturnWithdrawal, 
  //     withdrawalPeriod, currentAge]);
  useEffect(() => {
  calculate();
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [sipTenure, monthlySIP, yearlyStepUp, expectedReturnSIP, 
    immediateWithdrawal, monthlyWithdrawal, increaseWithdrawal, increasePercentage,
    expectedReturnWithdrawal, withdrawalPeriod, currentAge]);

  const handleFormSubmit = (userData) => {
    const element = document.getElementById('advanced-result-content');
    
    // html2pdf()
    //   .set({
    //     margin: 0.5,
    //     filename: `SIP_Plan_${userData.name || clientName || 'Report'}.pdf`,
    //     image: { type: 'jpeg', quality: 1 },
    //     html2canvas: { scale: 2 },
    //     jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
    //   })
    //   .from(element)
    //   .save();
    
    setShowForm(false);
    
    const whatsappMessage = `🏦 *Advanced SIP Investment Report*

👤 Client: ${userData.name || clientName || 'Investor'}

📊 *Investment Phase*
💰 Monthly SIP: ${formatCurrency(monthlySIP)}
📈 Yearly Step-Up: ${formatCurrency(yearlyStepUp)}
⏱️ SIP Tenure: ${sipTenure} Years
📊 Expected Return: ${expectedReturnSIP}%

💎 *Results*
✅ Total Invested: ${formatCurrency(result?.totalInvestedSIP)}
🚀 Final Corpus: ${formatCurrency(result?.sipFV)}
📈 Wealth Generated: ${formatCurrency(result?.totalReturnsSIP)}
⚡ Wealth Multiplier: ${result?.wealthMultiplier?.toFixed(2)}x

🔄 *Withdrawal Phase*
📅 Withdrawal Start Age: ${result?.withdrawalStartAge} Years
💸 Monthly Withdrawal: ${formatCurrency(monthlyWithdrawal)}
📈 Withdrawal Return: ${expectedReturnWithdrawal}%
📅 Withdrawal Duration: ${result?.withdrawalYears} Years
💰 Total Withdrawn: ${formatCurrency(result?.totalWithdrawn)}
🏦 Remaining Corpus: ${formatCurrency(result?.finalCorpus)}
${increaseWithdrawal ? `📈 Annual Increase: ${increasePercentage}%` : ''}

---
*Wisdom Consultancy*
📞 9726344477
📧 wisdom2secure@gmail.com`;

    window.open(`https://wa.me/${userData.phone}?text=${encodeURIComponent(whatsappMessage)}`, '_blank');
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white rounded-[32px] shadow-2xl border border-gray-100 p-6 md:p-8"
    >
      {/* Header */}
      <div className="mb-8">
        <div className="inline-flex items-center gap-3 bg-gradient-to-r from-blue-50 to-indigo-50 px-5 py-3 rounded-full mb-5">
          <div className="w-11 h-11 rounded-full bg-gradient-to-r from-[#2e56b8] to-[#4d7dff] flex items-center justify-center text-white">
            <FaChartLine />
          </div>
          <span className="font-semibold text-gray-700">Advanced SIP + SWP Planning</span>
        </div>
        
        <h3 className="text-3xl font-bold text-gray-800 mb-3">
          Smart Investment & Withdrawal Planner
        </h3>
        
        <p className="text-gray-500 leading-relaxed">
          Plan your wealth creation with SIP, step-up investments, and systematic withdrawal strategy
        </p>
      </div>

      {/* Main Grid */}
      <div className="grid lg:grid-cols-2 gap-8">
        {/* Input Section */}
        <div className="space-y-6">
          {/* Client Details */}
          <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl p-5">
            <h4 className="font-bold text-gray-700 mb-4 flex items-center gap-2">
              <FaUserClock /> Client Details
            </h4>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-1">Client Name</label>
                <input
                  type="text"
                  value={clientName}
                  onChange={(e) => setClientName(e.target.value)}
                  placeholder="Enter name"
                  className="w-full border border-gray-200 rounded-xl px-4 py-2 outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-1">Current Age (Years)</label>
                <input
                  type="number"
                  value={currentAge}
                  onChange={(e) => setCurrentAge(Number(e.target.value))}
                  className="w-full border border-gray-200 rounded-xl px-4 py-2 outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>
          </div>

          {/* Investment Phase */}
          <div className="bg-white border border-gray-100 rounded-2xl p-5 shadow-sm">
            <h4 className="font-bold text-gray-700 mb-4 flex items-center gap-2">
              <FaRupeeSign className="text-green-500" /> Investment Phase (SIP)
            </h4>
            
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-1">SIP Tenure (Years)</label>
                <input
                  type="range"
                  min="1"
                  max="50"
                  value={sipTenure}
                  onChange={(e) => setSipTenure(Number(e.target.value))}
                  className="w-full accent-blue-500"
                />
                <div className="text-center font-bold text-blue-600 mt-1">{sipTenure} Years</div>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-1">Monthly SIP Amount (₹)</label>
                <input
                  type="number"
                  value={monthlySIP}
                  onChange={(e) => setMonthlySIP(Number(e.target.value))}
                  className="w-full border border-gray-200 rounded-xl px-4 py-2 outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-1">Yearly Step-Up SIP Amount (₹)</label>
                <input
                  type="number"
                  value={yearlyStepUp}
                  onChange={(e) => setYearlyStepUp(Number(e.target.value))}
                  className="w-full border border-gray-200 rounded-xl px-4 py-2 outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-1">Expected Return from SIP (% CAGR)</label>
                <input
                  type="range"
                  min="4"
                  max="20"
                  step="0.5"
                  value={expectedReturnSIP}
                  onChange={(e) => setExpectedReturnSIP(Number(e.target.value))}
                  className="w-full accent-green-500"
                />
                <div className="text-center font-bold text-green-600 mt-1">{expectedReturnSIP}%</div>
              </div>
            </div>
          </div>

          {/* Withdrawal Phase - UPDATED SECTION */}
          <div className="bg-white border border-gray-100 rounded-2xl p-5 shadow-sm">
            <h4 className="font-bold text-gray-700 mb-4 flex items-center gap-2">
              <FaHandHoldingUsd className="text-orange-500" /> Withdrawal Phase (SWP)
            </h4>
            
            <div className="space-y-4">
              {/* Immediate Withdrawal after SIP Tenure - Yes/No Toggle */}
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-2">Immediate Withdrawal after SIP Tenure</label>
                <div className="flex gap-4">
                  <button
                    onClick={() => setImmediateWithdrawal(true)}
                    className={`px-6 py-2 rounded-xl font-semibold transition-all ${immediateWithdrawal ? 'bg-green-500 text-white' : 'bg-gray-100 text-gray-600'}`}
                  >
                    Yes
                  </button>
                  <button
                    onClick={() => setImmediateWithdrawal(false)}
                    className={`px-6 py-2 rounded-xl font-semibold transition-all ${!immediateWithdrawal ? 'bg-red-500 text-white' : 'bg-gray-100 text-gray-600'}`}
                  >
                    No
                  </button>
                </div>
                <p className="text-xs text-gray-400 mt-1">
                  {immediateWithdrawal ? 'Withdrawal starts immediately after SIP tenure' : 'You can choose when to start withdrawal'}
                </p>
              </div>
              
              {/* Withdrawal Start Age - Only shows when "No" is selected */}
              {!immediateWithdrawal && (
                <div className="bg-gray-50 rounded-xl p-4 border border-gray-200">
                  <label className="block text-sm font-medium text-gray-600 mb-2">Withdrawal Start Age (Years)</label>
                  <input
                    type="number"
                    value={customWithdrawalStartAge}
                    onChange={(e) => setCustomWithdrawalStartAge(Number(e.target.value))}
                    className="w-full border border-gray-200 rounded-xl px-4 py-2 outline-none focus:ring-2 focus:ring-orange-500"
                    placeholder="Enter age when you want to start withdrawal"
                  />
                  <p className="text-xs text-gray-400 mt-2">
                    * Enter any age you wish to start withdrawals (e.g., 51, 55, 60, 65, etc.)
                  </p>
                  <div className="mt-2 text-xs text-orange-600 bg-orange-50 p-2 rounded-lg">
                    💡 Your SIP ends at age {currentAge + sipTenure}. You can start withdrawals at any age after that.
                  </div>
                </div>
              )}
              
              {/* Monthly Withdrawal Amount */}
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-1">Monthly Withdrawal Amount (₹)</label>
                <input
                  type="number"
                  value={monthlyWithdrawal}
                  onChange={(e) => setMonthlyWithdrawal(Number(e.target.value))}
                  className="w-full border border-gray-200 rounded-xl px-4 py-2 outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              
              {/* Increase in Withdrawal Amount every Year - Yes/No Toggle */}
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-2">Increase in Withdrawal Amount every Year</label>
                <div className="flex gap-4">
                  <button
                    onClick={() => setIncreaseWithdrawal(true)}
                    className={`px-6 py-2 rounded-xl font-semibold transition-all ${increaseWithdrawal ? 'bg-green-500 text-white' : 'bg-gray-100 text-gray-600'}`}
                  >
                    Yes
                  </button>
                  <button
                    onClick={() => setIncreaseWithdrawal(false)}
                    className={`px-6 py-2 rounded-xl font-semibold transition-all ${!increaseWithdrawal ? 'bg-red-500 text-white' : 'bg-gray-100 text-gray-600'}`}
                  >
                    No
                  </button>
                </div>
              </div>
              
              {/* Assumed Increase (%) - Only show if Increase Withdrawal is Yes */}
              {increaseWithdrawal && (
                <div>
                  <label className="block text-sm font-medium text-gray-600 mb-1">Assumed Increase (%)</label>
                  <div className="flex items-center gap-3">
                    <input
                      type="range"
                      min="0"
                      max="10"
                      step="0.5"
                      value={increasePercentage}
                      onChange={(e) => setIncreasePercentage(Number(e.target.value))}
                      className="flex-1 accent-orange-500"
                    />
                    <span className="w-16 text-center font-bold text-orange-600 bg-orange-50 px-3 py-1 rounded-full">
                      {increasePercentage}%
                    </span>
                  </div>
                  <p className="text-xs text-gray-400 mt-1">Min 0% - Max 10%</p>
                </div>
              )}
              
              {/* Expected Return in Withdrawal Phase */}
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-1">Expected Return in Withdrawal Phase (% CAGR)</label>
                <input
                  type="range"
                  min="4"
                  max="15"
                  step="0.5"
                  value={expectedReturnWithdrawal}
                  onChange={(e) => setExpectedReturnWithdrawal(Number(e.target.value))}
                  className="w-full accent-orange-500"
                />
                <div className="text-center font-bold text-orange-600 mt-1">{expectedReturnWithdrawal}%</div>
              </div>
              
              {/* Withdrawal Period */}
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-1">Withdrawal Period (Years)</label>
                <input
                  type="range"
                  min="1"
                  max="50"
                  value={withdrawalPeriod}
                  onChange={(e) => setWithdrawalPeriod(Number(e.target.value))}
                  className="w-full accent-purple-500"
                />
                <div className="text-center font-bold text-purple-600 mt-1">{withdrawalPeriod} Years</div>
              </div>
            </div>
          </div>
        </div>

        {/* Results Section */}
        {result && (
          <div className="space-y-5">
            {/* Hero Result Card */}
            <div className="bg-gradient-to-r from-[#2e56b8] to-[#4d7dff] rounded-2xl p-6 text-white">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-14 h-14 rounded-xl bg-white/20 flex items-center justify-center">
                  <FaRocket className="text-2xl" />
                </div>
                <div>
                  <p className="text-sm opacity-80">
                    {!immediateWithdrawal && result.yearsBetween > 0 
                      ? `Corpus at Withdrawal Start (Age ${result.withdrawalStartAge})` 
                      : 'Total Corpus at Retirement'}
                  </p>
                  <h3 className="text-3xl font-bold">
                    {!immediateWithdrawal && result.yearsBetween > 0 
                      ? formatLargeNumber(result.corpusAtWithdrawalStart)
                      : formatLargeNumber(result.sipFV)}
                  </h3>
                </div>
              </div>
              
              <div className="grid grid-cols-2 gap-4 mt-4">
                <div className="bg-white/10 rounded-xl p-3">
                  <p className="text-xs opacity-80">Total Invested</p>
                  <p className="text-xl font-bold">{formatLargeNumber(result.totalInvestedSIP)}</p>
                </div>
                <div className="bg-white/10 rounded-xl p-3">
                  <p className="text-xs opacity-80">Wealth Generated</p>
                  <p className="text-xl font-bold">{formatLargeNumber(result.totalReturnsSIP)}</p>
                </div>
              </div>
            </div>
            
            {/* Summary Stats */}
            <div className="grid grid-cols-2 gap-3">
              <div className="bg-green-50 rounded-xl p-3 text-center">
                <p className="text-xs text-green-600 font-medium">Wealth Multiplier</p>
                <p className="text-xl font-bold text-green-700">{result.wealthMultiplier.toFixed(2)}x</p>
              </div>
              <div className="bg-blue-50 rounded-xl p-3 text-center">
                <p className="text-xs text-blue-600 font-medium">Monthly SIP (End)</p>
                <p className="text-xl font-bold text-blue-700">{formatCurrency(monthlySIP + (yearlyStepUp * sipTenure))}</p>
              </div>
            </div>
            
            {/* Withdrawal Summary */}
            <div className="bg-orange-50 rounded-xl p-4 border border-orange-100">
              <h5 className="font-bold text-orange-800 mb-3 flex items-center gap-2">
                <FaHandHoldingUsd /> Withdrawal Summary
              </h5>
              <div className="space-y-2 text-sm">
                <div className="flex justify-between">
                  <span className="text-gray-600">Withdrawal Start Age:</span>
                  <span className="font-bold">{result.withdrawalStartAge} Years</span>
                </div>
                {!immediateWithdrawal && result.yearsBetween > 0 && (
                  <div className="flex justify-between">
                    <span className="text-gray-600">Growth Period (Post SIP):</span>
                    <span className="font-bold text-orange-600">{result.yearsBetween} Years</span>
                  </div>
                )}
                <div className="flex justify-between">
                  <span className="text-gray-600">Withdrawal Duration:</span>
                  <span className="font-bold">{result.withdrawalYears} Years</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Total Withdrawn:</span>
                  <span className="font-bold text-green-600">{formatLargeNumber(result.totalWithdrawn)}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Remaining Corpus:</span>
                  <span className="font-bold text-blue-600">{formatLargeNumber(result.finalCorpus)}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Age Range:</span>
                  <span className="font-bold">{result.withdrawalStartAge} - {result.withdrawalEndAge} Years</span>
                </div>
                {increaseWithdrawal && (
                  <div className="flex justify-between">
                    <span className="text-gray-600">Annual Increase:</span>
                    <span className="font-bold text-orange-600">{increasePercentage}%</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Tabs for Charts */}
      {chartData.length > 0 && (
        <div className="mt-10">
          <div className="flex gap-3 mb-5 border-b">
            <button
              onClick={() => setActiveTab('investment')}
              className={`px-5 py-2 font-semibold transition-all ${activeTab === 'investment' ? 'border-b-2 border-blue-500 text-blue-600' : 'text-gray-500'}`}
            >
              <FaChartLine className="inline mr-2" /> Investment Growth
            </button>
            {withdrawalChartData.length > 0 && (
              <button
                onClick={() => setActiveTab('withdrawal')}
                className={`px-5 py-2 font-semibold transition-all ${activeTab === 'withdrawal' ? 'border-b-2 border-orange-500 text-orange-600' : 'text-gray-500'}`}
              >
                <FaHandHoldingUsd className="inline mr-2" /> Withdrawal Phase
              </button>
            )}
            <button
              onClick={() => setActiveTab('breakdown')}
              className={`px-5 py-2 font-semibold transition-all ${activeTab === 'breakdown' ? 'border-b-2 border-green-500 text-green-600' : 'text-gray-500'}`}
            >
              <FaChartPie className="inline mr-2" /> Investment Breakdown
            </button>
          </div>
          
          <div className="bg-gray-50 rounded-2xl p-5 h-[400px]">
            {activeTab === 'investment' && (
              <ResponsiveContainer width="100%" height="100%">
                <AreaChart data={chartData}>
                  <defs>
                    <linearGradient id="colorCorpus" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor="#2e56b8" stopOpacity={0.8}/>
                      <stop offset="95%" stopColor="#2e56b8" stopOpacity={0}/>
                    </linearGradient>
                  </defs>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="year" label={{ value: 'Years', position: 'bottom' }} />
                  <YAxis tickFormatter={(v) => formatLargeNumber(v)} />
                  <Tooltip formatter={(v) => formatLargeNumber(v)} />
                  <Legend />
                  <Area type="monotone" dataKey="invested" stroke="#ff9800" fillOpacity={0.2} fill="#ff9800" name="Invested Amount" />
                  <Area type="monotone" dataKey="sipValue" stroke="#2e56b8" fillOpacity={1} fill="url(#colorCorpus)" name="Portfolio Value" />
                </AreaChart>
              </ResponsiveContainer>
            )}
            
            {activeTab === 'withdrawal' && withdrawalChartData.length > 0 && (
              <ResponsiveContainer width="100%" height="100%">
                <LineChart data={withdrawalChartData}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="year" label={{ value: 'Withdrawal Years', position: 'bottom' }} />
                  <YAxis tickFormatter={(v) => formatLargeNumber(v)} />
                  <Tooltip formatter={(v) => formatLargeNumber(v)} />
                  <Legend />
                  <Line type="monotone" dataKey="balance" stroke="#2e56b8" name="Remaining Balance" strokeWidth={2} />
                  <Line type="monotone" dataKey="cumulativeWithdrawn" stroke="#69bf74" name="Total Withdrawn" strokeWidth={2} />
                </LineChart>
              </ResponsiveContainer>
            )}
            
            {activeTab === 'breakdown' && result && (
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie
                    data={[
                      { name: 'Total Invested', value: result.totalInvestedSIP },
                      { name: 'Returns Generated', value: result.totalReturnsSIP },
                    ]}
                    cx="50%"
                    cy="50%"
                    outerRadius={120}
                    dataKey="value"
                    label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
                  >
                    <Cell fill="#2e56b8" />
                    <Cell fill="#69bf74" />
                  </Pie>
                  <Tooltip formatter={(v) => formatLargeNumber(v)} />
                  <Legend />
                </PieChart>
              </ResponsiveContainer>
            )}
          </div>
        </div>
      )}

      {/* Action Buttons */}
      {result && (
        <div className="grid md:grid-cols-2 gap-4 mt-8">
          <button
            onClick={() => setShowForm(true)}
            className="flex items-center justify-center gap-3 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white py-4 rounded-xl font-semibold transition-all shadow-lg"
          >
            <FaFilePdf /> Download PDF Report
          </button>
          <button
            onClick={() => setShowForm(true)}
            className="flex items-center justify-center gap-3 bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white py-4 rounded-xl font-semibold transition-all shadow-lg"
          >
            <FaWhatsapp /> Share on WhatsApp
          </button>
        </div>
      )}

      {/* Hidden PDF Content */}
      {result && (
        <div id="advanced-result-content" style={{ display: 'none' }}>
          <div style={{ padding: '30px', fontFamily: 'Arial' }}>
            <div style={{ textAlign: 'center', borderBottom: '2px solid #1e3c72', paddingBottom: '20px', marginBottom: '20px' }}>
              <h1 style={{ color: '#1e3c72' }}>Wisdom Consultancy</h1>
              <p>E-44, Vasant Vihar Society, GIDC-Vadsar Road, Vadodara-390010</p>
              <p>📞 9726344477 | ✉ wisdom2secure@gmail.com</p>
              <h2 style={{ marginTop: '20px' }}>Advanced SIP Investment Report</h2>
              {clientName && <h3>Client: {clientName}</h3>}
            </div>
            
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <tbody>
                <tr><td style={{ padding: '8px' }}><strong>Current Age</strong></td><td style={{ padding: '8px', textAlign: 'right' }}>{currentAge} Years</td></tr>
                <tr><td style={{ padding: '8px' }}><strong>SIP Tenure</strong></td><td style={{ padding: '8px', textAlign: 'right' }}>{sipTenure} Years</td></tr>
                <tr><td style={{ padding: '8px' }}><strong>Monthly SIP</strong></td><td style={{ padding: '8px', textAlign: 'right' }}>{formatCurrency(monthlySIP)}</td></tr>
                <tr><td style={{ padding: '8px' }}><strong>Yearly Step-Up</strong></td><td style={{ padding: '8px', textAlign: 'right' }}>{formatCurrency(yearlyStepUp)}</td></tr>
                <tr><td style={{ padding: '8px' }}><strong>Expected Return (SIP)</strong></td><td style={{ padding: '8px', textAlign: 'right' }}>{expectedReturnSIP}%</td></tr>
                <tr style={{ background: '#f0f0f0' }}><td style={{ padding: '8px' }}><strong>Total Invested</strong></td><td style={{ padding: '8px', textAlign: 'right' }}><strong>{formatLargeNumber(result.totalInvestedSIP)}</strong></td></tr>
                <tr style={{ background: '#f0f0f0' }}><td style={{ padding: '8px' }}><strong>Final Corpus</strong></td><td style={{ padding: '8px', textAlign: 'right' }}><strong>{formatLargeNumber(result.sipFV)}</strong></td></tr>
                <tr style={{ background: '#f0f0f0' }}><td style={{ padding: '8px' }}><strong>Wealth Generated</strong></td><td style={{ padding: '8px', textAlign: 'right' }}><strong>{formatLargeNumber(result.totalReturnsSIP)}</strong></td></tr>
                <tr style={{ background: '#f0f0f0' }}><td style={{ padding: '8px' }}><strong>Wealth Multiplier</strong></td><td style={{ padding: '8px', textAlign: 'right' }}><strong>{result.wealthMultiplier.toFixed(2)}x</strong></td></tr>
              </tbody>
            </table>
            
            <h3 style={{ marginTop: '20px' }}>Withdrawal Phase</h3>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <tbody>
                <tr><td style={{ padding: '8px' }}><strong>Withdrawal Start Age</strong></td><td style={{ padding: '8px', textAlign: 'right' }}>{result.withdrawalStartAge} Years</td></tr>
                <tr><td style={{ padding: '8px' }}><strong>Monthly Withdrawal</strong></td><td style={{ padding: '8px', textAlign: 'right' }}>{formatCurrency(monthlyWithdrawal)}</td></tr>
                <tr><td style={{ padding: '8px' }}><strong>Withdrawal Duration</strong></td><td style={{ padding: '8px', textAlign: 'right' }}>{result.withdrawalYears} Years</td></tr>
                <tr><td style={{ padding: '8px' }}><strong>Total Withdrawn</strong></td><td style={{ padding: '8px', textAlign: 'right' }}>{formatLargeNumber(result.totalWithdrawn)}</td></tr>
                <tr><td style={{ padding: '8px' }}><strong>Remaining Corpus</strong></td><td style={{ padding: '8px', textAlign: 'right' }}>{formatLargeNumber(result.finalCorpus)}</td></tr>
                {increaseWithdrawal && <tr><td style={{ padding: '8px' }}><strong>Annual Increase</strong></td><td style={{ padding: '8px', textAlign: 'right' }}>{increasePercentage}%</td></tr>}
              </tbody>
            </table>
            
            <div style={{ marginTop: '30px', padding: '20px', background: '#f5f7fa', borderRadius: '10px' }}>
              <h3>Disclaimer</h3>
              <p style={{ fontSize: '12px' }}>Mutual Fund investments are subject to market risks. Read all scheme related documents carefully before investing. Past performance is not indicative of future returns.</p>
            </div>
          </div>
        </div>
      )}

      {/* Form Modal */}
      {showForm && (
        <CalculatorForm
          onSubmit={handleFormSubmit}
          onClose={() => setShowForm(false)}
          calculatorType="ComboCalculator"
        />
      )}
    </motion.div>
  );
};

export default ComboCalculator;

